import { secondsToMilliseconds } from "date-fns";
import { dynamicConfig } from "../../../statsig/gates";
import { Statsig } from "../../../statsig/StatsigProvider";

const TELEHEALTH_CONFIG_SESSION_INTERACTION_PROMPT_CONFIG_KEY =
  "session_interaction_prompt_config";

const DEFAULT_SESSION_INTERACTION_PROMPT_CONFIG = {
  message:
    "Your session is about to start — click or tap the screen to continue.",
  showAfterMs: secondsToMilliseconds(3),
};

export function getSessionInteractionInfo(): typeof DEFAULT_SESSION_INTERACTION_PROMPT_CONFIG {
  return {
    ...DEFAULT_SESSION_INTERACTION_PROMPT_CONFIG,
    ...Statsig.getDynamicConfig(dynamicConfig).get<
      typeof DEFAULT_SESSION_INTERACTION_PROMPT_CONFIG
    >(
      TELEHEALTH_CONFIG_SESSION_INTERACTION_PROMPT_CONFIG_KEY,
      DEFAULT_SESSION_INTERACTION_PROMPT_CONFIG,
    ),
  };
}
